import { route } from '@/utils/build'
const component = (path) => resolve => require(['@/pages/payment/views/' + path], resolve)

/**
 * 注册无限卡家庭卡相关路由
 */
export default [
  // 家庭卡承诺书
  route('/subVip-commitmentView', 'subVip-commitmentView', component('goods/subVip/commitmentView/index')),
  // 提交资料
  route('/subVip-submitDetails', 'subVip-submitDetails', component('goods/subVip/submitDetails/index')),
  route('/subVip-submitSign', 'subVip-submitSign', component('goods/subVip/submitDetails/submitSign')),
  route('/subVip-makeCommitment', 'subVip-makeCommitment', component('goods/subVip/submitDetails/makeCommitment')),
  // 家庭卡支付成功
  route('/subVip-paySuccess', 'subVip-paySuccess', component('goods/subVip/subVip-paySuccess/index')),
  // 审核进度
  route('/subVip-examineStep', 'subVip-examineStep', component('goods/subVip/examineStep/index'))
];